import { EmoticonDevilOutlineIcon } from './EmoticonDevilOutlineIcon';

/**
 * author: Austin Andrews
 * id 916B1319-9E91-48C0-AD65-B21B599D8FCA
 * name emoticon-devil-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-devil-outline.svg
 * tags
 * - Emoji 
 */
export const FaceDevilOutlineIcon = EmoticonDevilOutlineIcon;
export default FaceDevilOutlineIcon